/**
 * Adds a list of event handlers to the specified DOM node
 * @param {Element} el The node to add events to
 * @param {String} events Space-separated list of events to listen to
 * @param {EventListenerOrEventListenerObject} handler the event handler
 * @param {boolean | AddEventListenerOptions} [options] any options to pass to addEventListener
 */
export function addListeners (el, events, handler, options) {
  events.split(' ').forEach((event) => {
    el.addEventListener(event, handler, options);
  });
}

/**
 * Adds a list of passive event handlers to the specified DOM node. Passive event listeners are recommended to improve
 * performance. Passive event handlers cannot call "preventDefault" (will be ignored).
 * @param {Element} el The node to add events to
 * @param {String} events Space-separated list of events to listen to
 * @param {EventListenerOrEventListenerObject} handler the event handler
 */
export function addPassiveListeners (el, events, handler) {
  addListeners(el, events, handler, { passive: true });
}
